
import './index.scss';
import InventoryControl from 'components/InventoryControl';

export const InventoryControlPage = () => {

	return <div> <InventoryControl /></div>;
};
